import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./store/Store";
import App from "./App";
import { SocketProvider } from "./services/SocketProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <SocketProvider>
      <App />
    </SocketProvider>
  </Provider>
);
